import React, { useEffect, useState ,useContext} from 'react';
import axios from 'axios';
import { fetchPackages } from '../redux/packageSlice';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { AppContext } from '../context/AppContext';
   

const Purchase = () => {
  const [customerName, setCustomerName] = useState('');
  const [address, setAddress] = useState('');
  const [finalAmount, setFinalAmount] = useState(100.00); // Example amount
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const { user, isAuthenticated, logout } = useContext(AppContext);

  const dispatch = useDispatch();
  const { packages, status } = useSelector((state) => state.package);

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const planId = parseInt(queryParams.get('planId'), 10); 
  const service = queryParams.get('service')?.toLowerCase() || ''; 
  const category = queryParams.get('category')?.toLowerCase() || ''; 
  const valid = parseInt(queryParams.get('valid'), 10); 



  const userId = user?.data?.id;
  const mobile = user?.data?.mobile;
  const [transactionId, setTransactionId] = useState('e3459385735');
  const [paymentGetaway, setPaymentGetaway] = useState('RazorPay');


  useEffect(() => {
    dispatch(fetchPackages());
  }, [dispatch]);

  const handleSubmit = async (e) => {
    e.preventDefault();


    const formData = {
        planId,
        userId,
        transactionId,
        mobile,
        paymentGetaway,
        valid
        // Add more fields as needed
      };
    const token = localStorage.getItem('authToken');

    setLoading(true);
    setError('');

    try {
      const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/subscribePackage`, // Replace with your API endpoint
        formData,
        {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        }
      );

        if(response.status)
        {
            alert('Request Successful!');
        }
        else{
            alert(response.message)
        }
    
     
    } catch (err) {
      // Handle error response
      console.error('Error:', err);
      setError('There was an error. Please try again.');
    } finally {
      setLoading(false);
    }
  };

 // Helper function to render plans
 const renderPlans = (plans) => {
    if (!plans || plans.length === 0) {
      return <p>No plans available.</p>;
    }
    return (
      <div className="plans-container">
     {plans
  .filter(plan => plan.id === planId)
  .map((plan) => {
    
    return (
      <div key={plan.id} className="plan">
        <h3>{plan.name} - {plan.package_category}</h3>
        <div className="plan-details">
          <p>Plan Validity: {plan.validity_days} Days</p>
          <p>Position in Search Result: {plan.position_slot}</p>
          <p>Matching Buyers: {plan.matching_buyers || '✗'}</p>
          <p>Relationship Manager Assistance: {plan.relationship_manager ? '✓' : '✗'}</p>
          <p>Field Visit Assistance: {plan.field_visit_assistance ? '✓' : '✗'}</p>
          <p>Professional Photoshoot: {plan.photoshoot_assistance ? '✓' : '✗'}</p>
          <p className="price">Final Amount to be Paid : ₹ {plan.price}</p>
        </div>
      </div>
    );
  })}

      </div>
    );
  };

  // Define plans data based on the API response structure
  const plansData = {
    commercial: {
      'for-sell': renderPlans(packages?.commercial?.sell || []),
      'for-lease': renderPlans(packages?.commercial?.lease || []),
      'for-rent': renderPlans(packages?.commercial?.rent || []),
      'for-pg': renderPlans(packages?.commercial?.pg || []),
    },
    residential: {
      'for-sell': renderPlans(packages?.residential?.sell || []),
      'for-rent': renderPlans(packages?.residential?.rent || []),
      'for-pg': renderPlans(packages?.residential?.pg || []),
    },
  };

  return (
    <div className="container p-5">
      <div className="row p-5">
        {/* Left side - Product Details */}
        <div className="col-md-6">
          <h4>Product Details</h4>
          <div className="plans-container">
          {plansData[category][`for-${service}`]}
          </div>

          <button
            type="submit"
            className="btn btn-primary"
            id="submitButton"
            onClick={handleSubmit}
            disabled={loading}
          >
            {loading ? 'Submitting...' : 'Submit'}
          </button>
          {error && <p className="text-danger">{error}</p>}
        </div>

        {/* Right side - Final Amount */}
        {/* <div className="col-md-6">
          <h4>Final Amount</h4>
          <p>Total: <span id="finalAmount">₹ {finalAmount}</span></p>
          <button
            type="submit"
            className="btn btn-primary"
            id="submitButton"
            onClick={handleSubmit}
            disabled={loading}
          >
            {loading ? 'Submitting...' : 'Submit'}
          </button>
          {error && <p className="text-danger">{error}</p>}
        </div> */}
      </div>
    </div>
  );
};

export default Purchase;
